import loadable from '@loadable/component';
import { OnlyContentTypes } from 'govbr.frontend.policy/helpers/BlockConditions';
import { defineMessages } from 'react-intl';

import { personAgendaSchema } from './schema';

import iconSVG from '@plone/volto/icons/enterprise.svg';

const PersonAgendaView = loadable(
  () => import(/* webpackChunkName: "PersonAgenda" */ './PersonAgendaView'),
);
const PersonAgendaEdit = loadable(
  () => import(/* webpackChunkName: "PersonAgenda" */ './PersonAgendaEdit'),
);

defineMessages({
  appointmentCalendar: {
    id: 'Appointment Calendar',
    defaultMessage: 'Appointments calendar',
  },
});

const applyConfig = (config) => {
  config.blocks.blocksConfig.personAgendaBlock = {
    id: 'personAgendaBlock',
    title: 'Appointment Calendar',
    group: 'organization',
    icon: iconSVG,
    view: PersonAgendaView,
    edit: PersonAgendaEdit,
    blockSchema: personAgendaSchema,
    restricted: OnlyContentTypes(['Agenda']),
    mostUsed: true,
    sidebarTab: 1,
    security: {
      addPermission: [],
      view: [],
    },
  };

  return config;
};

export default applyConfig;
